
import React from 'react';
import Nanvbarm from './NavBarM'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Collapse from 'react-bootstrap/Collapse'
import InputGroup from 'react-bootstrap/InputGroup'
import MuiTable from './MuiTable'

class CallCenterMain extends React.Component{
    constructor(props){
        super();
        this.state = {
            data:[],
            open:false,
            selected: {
                status: -1,
                type: -1,
                search:''
            },
            userRole:localStorage.getItem('role')
        }
    }
    setOpen(arg){
        this.setState({
            open: arg
          });
    }
    changeType(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                type: event.target.value

            }
        })
    }

    changeStatus(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                status: event.target.value
            }
        })
    }

    changeSearch(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                search: event.target.value
            }
        })
    }
    render(){
        return (
            <div ref={this.wrapper}>
                <Nanvbarm user = {1}/>
                <Container className='row-content px-3' ref={this.wrapper} fluid>
                    <Row>
                        <Col sm={4}>
                            <p>
                                <Button variant='secondary' size= 'md' aria-controls="example-collapse-text" onClick={() => this.setOpen(!this.state.open)} aria-expanded={this.state.open}>
                                    ფილტრი
                                </Button>
                            </p>
                            <Collapse in={this.state.open} ref = {this.wrapper}>
                                <div>
                                    <InputGroup className="mb-4">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text id="basic-addon1">ტიპი</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control as="select" ref={this.myRef}  onChange={(event)=>this.changeType(this,event)}>
                                            <option value={-1} defaultValue>ყველა</option>
                                            <option value="new_stb">ახალი STB</option>
                                            <option value="replace_stb">შესაცვლელია STB</option>
                                            <option value="remove_stb">წამოსაღებია STB</option>
                                            <option value="replace_remote_new">ახალი პულტი</option>
                                            <option value="replace_remote_secondary">მეორადი პულტი</option>
                                            <option value="replace_charger">კვების ბლოკის შეცვლა</option>
                                            <option value="replace_hdmi_wire">HDMI კაბელის შეცვლა</option>
                                            <option value="replace_rci_wire">RCI კაბელის შეცვლა</option>
                                            <option value="replace_ethernet_wire">Ethernet კაბელის შემოწმება/შეცვლა</option>
                                            <option value="other">სხვა</option>
                                        </Form.Control>
                                    </InputGroup>
                                    <InputGroup className="mb-4">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text id="basic-addon1">სტატუსი</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control as="select"  onChange={(event)=>this.changeStatus(this,event)}>
                                            
                                            <option value={-1}>ყველა</option>
                                            <option value={3}>გახსნილი</option>
                                            <option value={1}>მიმდინარე</option>
                                            <option value={2}>შესრულებული</option>
                                            <option value={0}>დახურული</option>
                                        </Form.Control>
                                    </InputGroup>
                                </div>
                            </Collapse>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <InputGroup className="mb-4">
                                <InputGroup.Prepend >
                                    <InputGroup.Text size="sm" id="basic-addon1">ძებნა</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control type = "mail" onChange={(event)=>this.changeSearch(this,event)}/>    
                            </InputGroup>
                        </Col>            
                    </Row>
                </Container>
                <Container  fluid>
                    <Row>
                        <MuiTable 
                            title = "დავალებები" 
                            type = {this.state.selected.type} 
                            status = {this.state.selected.status} 
                            search = {this.state.selected.search}
                            role = {this.state.userRole}
                        />
                    </Row>
                </Container>
            </div>
        )
    }
}
export default CallCenterMain;